<div class="bg-gray-100 text-black p-[10px]">
    <h3 class="mt-[20px] mb-0 mx-auto w-fit">{{details()?.ScholarshipYear}} Scholarship Application</h3>
    <p>
        Please print a copy of your finalized application for your records.
    </p>
    <p>
        <strong>
            REMINDER: You must email any scholarship specific required documents including FAFSA Student Aid Summary to
            <span class="text-red-500">pefscholarships@polk-fl.net</span> by {{details()?.Deadline}} to be considered for those scholarships.
            Be sure to include your student id number, and your first and last name in the subject of the email when sending over any required documents.
        </strong>
    </p>
    <div class="header">
        DEMOGRAPHIC INFORMATION
    </div>
    <div class="flex justify-between gap-[5px]">
        <div>
            <div>
                <span class="text-gray-500 inline-block p-[5px] min-w-[110px]">First Name:</span>
                <strong>{{details()?.FirstName}}</strong>
            </div>
            <div>
                <span class="text-gray-500 inline-block p-[5px] min-w-[110px]">Student ID:</span>
                <strong>{{details()?.StudentID}}</strong>
            </div>
            <div>
                <span class="text-gray-500 inline-block p-[5px] min-w-[110px]">Address:</span>
                <strong>{{details()?.Address}}</strong>
            </div>
            <div>
                <span class="text-gray-500 inline-block p-[5px] min-w-[110px]">City:</span>
                <strong>{{details()?.City}}</strong>
            </div>
            <div>
                <span class="text-gray-500 inline-block p-[5px] min-w-[110px]">Phone:</span>
                <strong>{{details()?.Phone}}</strong>
            </div>
        </div>
        <div>
            <div>
                <span class="text-gray-500 inline-block p-[5px] min-w-[110px]">Middle Name:</span>
                <strong>{{details()?.MiddleName}}</strong>
            </div>
            <div>
                <span class="text-gray-500 inline-block p-[5px] min-w-[110px]">School:</span>
                <strong>{{details()?.School}}</strong>
            </div>
            <div>
                <span class="text-gray-500 inline-block p-[5px] min-w-[110px]">Apt #:</span>
                <strong>{{details()?.AptNumber}}</strong>
            </div>
            <div>
                <span class="text-gray-500 inline-block p-[5px] min-w-[110px]">State:</span>
                <strong>{{details()?.State}}</strong>
            </div>
            <div>
                <span class="text-gray-500 inline-block p-[5px] min-w-[110px]">Personal Email:</span>
                <strong>{{details()?.PersonalEmail}}</strong>
            </div>
        </div>
        <div>
            <div>
                <span class="text-gray-500 inline-block p-[5px] min-w-[110px]">Last Name:</span>
                <strong>{{details()?.LastName}}</strong>
            </div>
            <div class="inline-block mb-[29px]"></div>
            <div>
                <span class="text-gray-500 inline-block p-[5px] min-w-[110px]">DOB:</span>
                <strong>{{details()?.BirthDate}}</strong>
            </div>
            <div>
                <span class="text-gray-500 inline-block p-[5px] min-w-[110px]">Zip:</span>
                <strong>{{details()?.Zip}}</strong>
            </div>
            <div>
                <span class="text-gray-500 inline-block p-[5px] min-w-[110px]">School Email:</span>
                <strong>{{details()?.SchoolEmail}}</strong>
            </div>
        </div>
    </div>
    <div class="header">
        ACADEMIC INFORMATION
    </div>
    <div>
        <span class="text-gray-500 inline-block p-[5px] min-w-[300px]">Weighted GPA:</span>
        <strong>{{details()?.GPA}}</strong>
    </div>
    <div class="flex gap-[20px] justify-between">
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[300px]">Best SAT Math:</span>
            <strong>{{details()?.MathSAT}}</strong>
        </div>
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[300px]">Best SAT Reading:</span>
            <strong>{{details()?.ReadingSAT}}</strong>
        </div>
    </div>
    <div class="flex gap-[20px] justify-between">
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[300px]">Best ACT:</span>
            <strong>{{details()?.ACT}}</strong>
        </div>
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[300px]">Best CLT:</span>
            <strong>{{details()?.CLT}}</strong>
        </div>
    </div>
    <div class="flex gap-[20px] justify-between">
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[300px]">Passed Alg1/Geo EOC (or Concordant):</span>
            <strong>{{details()?.PassedAlgEoc}}</strong>
        </div>
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[300px]">Passed FSA Reading (or Concordant):</span>
            <strong>{{details()?.PassedReading}}</strong>
        </div>
    </div>
    <div class="flex gap-[20px] justify-between">
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[300px]">Have you completed the FFAA:</span>
            <strong>{{details()?.CompletedFFAA}}</strong>
        </div>
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[300px]">Florida Pre-Paid:</span>
            <strong>{{details()?.HavePrepaid}}</strong>
        </div>
    </div>
    <div class="flex gap-[20px] justify-between">
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[300px]">Student Aid Index:</span>
            <strong>{{details()?.Sai}}</strong>
        </div>
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[300px]">Accept Need Based Scholarships:</span>
            <strong>{{details()?.NeedBased}}</strong>
        </div>
    </div>
    <div class="header">
        HOUSEHOLD INFORMATION
    </div>
    <div class="flex gap-[20px] justify-between">
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[340px]">Father's Name:</span>
            <strong>{{details()?.FatherName}}</strong>
        </div>
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[340px]">Mother's Name:</span>
            <strong>{{details()?.MotherName}}</strong>
        </div>
    </div>
    <div class="flex gap-[20px] justify-between">
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[340px]">Father's Employer:</span>
            <strong>{{details()?.FatherEmployer}}</strong>
        </div>
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[340px]">Mother's Employer:</span>
            <strong>{{details()?.MotherEmployer}}</strong>
        </div>
    </div>
    <div class="flex gap-[20px] justify-between">
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[340px]">Number of people living in home:</span>
            <strong>{{details()?.HouseholdSize}}</strong>
        </div>
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[340px]">Number of family members attending college:</span>
            <strong>{{details()?.FamilyInCollegeNumber}}</strong>
        </div>
    </div>
    <div class="header">
        MISCELLANEOUS INFORMATION
    </div>
    <div class="flex gap-[20px]">
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[220px]">Selected Institution:</span>
            <strong>{{details()?.SelectedInstitution}}</strong>
        </div>
        <div>
            <span class="text-gray-500 inline-block p-[5px] min-w-[220px]">Accepted:</span>
            <strong>{{details()?.Accepted}}</strong>
        </div>
    </div>
    <div>
        <span class="text-gray-500 inline-block p-[5px] min-w-[220px]">Intended College Major:</span>
        <strong>{{details()?.IntendedMajor}}</strong>
    </div>
    <div>
        <div class="text-gray-500 p-[5px]">Why did you choose this major?</div>
        <div class="pl-[50px]"><strong>{{details()?.WhyMajor}}</strong></div>

    </div>
    <div>
        <span class="text-gray-500 inline-block p-[5px] min-w-[220px]">Current # Paid Work Hours:</span>
        <strong>{{details()?.WorkHours}}</strong>
    </div>
    <div>
        <div class="text-gray-500 p-[5px]">Past & Present Employment History:</div>
        <div class="pl-[50px]"><strong>{{details()?.EmploymentHistory}}</strong></div>
    </div>
    <div>
        <span class="text-gray-500 inline-block p-[5px] min-w-[220px]">Community Service Hours:</span>
        <strong>{{details()?.CommunityServiceHours}}</strong>
    </div>
    <div>
        <div class="text-gray-500 p-[5px]">Type of community service hours:</div>
        <div class="pl-[50px]"><strong>{{details()?.VolunteerDescription}}</strong></div>
    </div>
    <div>
        <div class="text-gray-500 p-[5px]">Other Scholarship Information:</div>
        <div class="pl-[50px]"><strong>{{details()?.OtherAwards}}</strong></div>
    </div>
    <div class="header">
        STUDENT ESSAY
    </div>
    <div class="pl-[50px]">{{details()?.Essay}}</div>
    <div>
        <span class="text-gray-500 inline-block p-[5px] min-w-[300px]">Did you use an AI platform to enhance your general essay?:</span>
        <strong>{{details()?.EssayAI}}</strong>
    </div>
    <div>
        <span class="text-gray-500 inline-block p-[5px] min-w-[300px]">How did you utilize AI to enhance your essay?:</span>
        <strong>{{details()?.AiHow}}</strong>
    </div>
    <div class="header">
        SELECTED SCHOLARSHIPS
    </div>
    <ul>
        @for (sch of details()?.SelectedScholarships; track sch.ScholarshipName) {
        <li>
            <strong class="color">{{sch.ScholarshipName}}</strong>
            @if (sch?.AdditionalQuestion != null) {
            <div class="flex justify-start items-baseline my-[10px]">
                <div class="text-gray-500 p-[5px] ml-[20px] min-w-[255px]">Additional Question:</div>
                <div class="flex flex-col">
                    <div>{{sch.AdditionalQuestion}}</div>
                    @if (sch.AqHaveYesNo === true) {
                    <div class="my-[5px] mx-0">Yes/No Response: <strong>{{sch.AdditionalQuestionYesNoResponse ? 'Yes' : 'No'}}</strong></div>
                    }
                    @if (sch.AqHaveText === true)
                    {
                    <div class="my-[5px] mx-0">Text Response: <strong>{{sch.AdditionalQuestionTextResponse}}</strong></div>
                    }
                </div>
            </div>
            }
            @if (sch?.EmployeeNameLabel != null) {
            <div>
                <div class="text-gray-500 inline-block p-[5px] ml-[20px] min-w-[255px]">{{sch?.EmployeeNameLabel}}:</div>
                <strong>{{sch.EmployeeNameResponse}}</strong>
            </div>
            }
            @if (sch?.EmployeeLocationLabel != null) {
            <div>
                <div class="text-gray-500 inline-block p-[5px] ml-[20px] min-w-[255px]">{{sch?.EmployeeLocationLabel}}:</div>
                <strong>{{sch.EmployeeLocationResponse}}</strong>
            </div>
            }
            @if (sch?.EmployeeSSNLabel != null) {
            <div>
                <div class="text-gray-500 inline-block p-[5px] ml-[20px] min-w-[255px]">{{sch?.EmployeeSSNLabel}}:</div>
                <strong>{{sch.EmployeeSSNResponse}}</strong>
            </div>
            }
            @if (sch?.StoreLocationNumberLabel != null) {
            <div>
                <div class="text-gray-500 inline-block p-[5px] ml-[20px] min-w-[255px]">{{sch?.StoreLocationNumberLabel}}:</div>
                <strong>{{sch.StoreLocationNumberResponse}}</strong>
            </div>
            }
            @if (sch?.AccountNameLabel != null) {
            <div>
                <div class="text-gray-500 inline-block p-[5px] ml-[20px] min-w-[255px]">{{sch?.AccountNameLabel}}:</div>
                <strong>{{sch.AccountNameResponse}}</strong>
            </div>
            }
            @if (sch?.AccountNumberLabel != null) {
            <div>
                <div class="text-gray-500 inline-block p-[5px] ml-[20px] min-w-[255px]">{{sch?.AccountNumberLabel}}:</div>
                <strong>{{sch.AccountNumberResponse}}</strong>
            </div>
            }
            @if (sch?.ParentNameLabel != null) {
            <div>
                <div class="text-gray-500 inline-block p-[5px] ml-[20px] min-w-[255px]">{{sch?.ParentNameLabel}}:</div>
                <strong>{{sch.ParentNameResponse}}</strong>
            </div>
            }
            @if (sch?.ParentSSNLabel != null) {
            <div>
                <div class="text-gray-500 inline-block p-[5px] ml-[20px] min-w-[255px]">{{sch?.ParentSSNLabel}}:</div>
                <strong>{{sch.ParentSSNResponse}}</strong>
            </div>
            }
            @if (sch?.ParentOrganizationLabel != null) {
            <div>
                <div class="text-gray-500 inline-block p-[5px] ml-[20px] min-w-[255px]">{{sch?.ParentOrganizationLabel}}:</div>
                <strong>{{sch.ParentOrganizationResponse}}</strong>
            </div>
            }
            @if (sch?.ParentDepartmentLabel != null) {
            <div>
                <div class="text-gray-500 inline-block p-[5px] ml-[20px] min-w-[255px]">{{sch?.ParentDepartmentLabel}}:</div>
                <strong>{{sch.ParentDepartmentResponse}}</strong>
            </div>
            }
            @if (sch?.ScholarshipEssayLabel != null) {
            <div>
                <div class="text-gray-500 p-[5px] ml-[20px] min-w-[255px]">{{sch?.ScholarshipEssayLabel}}:</div>
                <div class="pl-[50px]"><strong>{{sch.ScholarshipEssayResponse}}</strong></div>
            </div>
            }
            @if (sch?.ScholarshipEssay2Label != null) {
            <div>
                <div class="text-gray-500 p-[5px] ml-[20px] min-w-[255px]">{{sch?.ScholarshipEssay2Label}}:</div>
                <div class="pl-[50px]"><strong>{{sch.ScholarshipEssay2Response}}</strong></div>
            </div>
            }
        </li>
        }
    </ul>
    <div class="header">
        COURSE WORK
    </div>
    <h4 class="mt-[20px] mb-0 mx-auto w-fit">Courses - Completed</h4>
    <table class="courses">
        <tr>
            <th class="pr-[5px]">School Year</th>
            <th class="pr-[5px]">District</th>
            <th class="pr-[5px]">School</th>
            <th class="pr-[5px]">Grade Level</th>
            <th class="pr-[5px]">Term</th>
            <th class="pr-[5px]">Course#</th>
            <th class="pr-[5px]">Course</th>
            <th class="pr-[5px]">Subject</th>
            <th class="pr-[5px]">Flag</th>
            <th class="pr-[5px]">Final Grade</th>
            <th class="pr-[5px]">Attempted</th>
            <th>Earned</th>
        </tr>
        @for (c of details()?.CompletedCourses; track c.Id) {
        <tr>
            <td class="pr-[5px]">{{c.SchoolYear}}</td>
            <td class="pr-[5px]">{{c.District}}</td>
            <td class="pr-[5px]">{{c.SchoolInfo}}</td>
            <td class="pr-[5px]">{{c.GradeLevel}}</td>
            <td class="pr-[5px]">{{c.Term}}</td>
            <td class="pr-[5px]">{{c.CourseNumber}}</td>
            <td class="pr-[5px]">{{c.CourseName}}</td>
            <td class="pr-[5px]">{{c.Subject}}</td>
            <td class="pr-[5px]">{{c.Flag}}</td>
            <td class="pr-[5px]">{{c.FinalGrade}}</td>
            <td class="pr-[5px]">{{c.CreditAttempted}}</td>
            <td>{{c.CreditEarned}}</td>
        </tr>
        }
    </table>
    <h4 class="mt-[20px] mb-0 mx-auto w-fit">Courses - In Progress</h4>
    <table class="courses">
        <tr>
            <th class="pr-[5px]">School Year</th>
            <th class="pr-[5px]">District</th>
            <th class="pr-[5px]">School</th>
            <th class="pr-[5px]">Grade Level</th>
            <th class="pr-[5px]">Term</th>
            <th class="pr-[5px]">Course#</th>
            <th class="pr-[5px]">Course</th>
            <th>Subject</th>
        </tr>
        @for (c of details()?.IncompleteCourses; track c.Id) {
        <tr>
            <td class="pr-[5px]">{{c.SchoolYear}}</td>
            <td class="pr-[5px]">{{c.District}}</td>
            <td class="pr-[5px]">{{c.SchoolInfo}}</td>
            <td class="pr-[5px]">{{c.GradeLevel}}</td>
            <td class="pr-[5px]">{{c.Term}}</td>
            <td class="pr-[5px]">{{c.CourseNumber}}</td>
            <td class="pr-[5px]">{{c.CourseName}}</td>
            <td>{{c.Subject}}</td>
        </tr>
        }
    </table>
    <div class="header">
        FINAL APPROVAL
    </div>
    <p>
        By signing this document, we attest that all information is true and accurate to the best of our knowledge.
        Our signatures also give permission for any information contained in this application to be shared with donors or committee members other than Polk Education Foundation staff for the purposes of recipient selection.
        Permission to use the student's name and or picture for scholarship recognition is also granted.
        I understand that if the requested documents are not submitted with the application, that the application will not be considered.
        Please note: Scholarships administered by the PEF are paid out only after receipt of funds from a donor.
        This also stands for multiple year awards with annual renewable payments.
    </p>
    <div class="flex gap-[20px]">
        <div>
            <span>Student Signature: </span>
            <img [src]="details()?.StudentSignature" height="75" class="border border-solid border-black rounded-[8px]" />
        </div>
        <div>
            <span>Parent/Guardian Signature: </span>
            <img [src]="details()?.ParentSignature" height="75" class="border border-solid border-black rounded-[8px]" />
        </div>
    </div>
</div>